import { axiosInstance } from "../../Utils/AxiosInstance";

const BASE = "/StoreProcurementReports";

const call = async (fn) => {
  try {
    const response = await fn();
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

// name: PoFulfillment | PrConversion | ThreeWayMatch | VendorAging | ProcurementSpend | VendorPerformance |
// StockValuation | GrnRegister | ReorderAlerts | StoreDashboard | ProcurementDashboard
export const GetStoreProcurementReportApi = (name, params) =>
  call(() => axiosInstance.get(`${BASE}/${name}`, { params }));
